import React, { Component } from 'react'
import { Link, useNavigate,  } from 'react-router-dom'
import { firebaseAuth , firestore } from "./Firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { doc, setDoc, collection, getDocs, getDoc } from "firebase/firestore"; 

export default class Register extends Component {
  constructor(props){
    super(props)
    this.state ={
      Captcha : false,
      Name: "",
      MNumber: "",
      otp: "",
      password: "",
      CPassword: "",
      AadhaarNo : "",
      DOB : "",
      fill1:false,
      fill2:false,
      fill3:false,
      fill4:false,
      fill5:false,
      fill6:false,
      fill7:false,
      fill8:false,
      fill9:false,
      fill10:false,
      fill11:false,
    } 
  }

  HandleAge = () =>{
    let date = new Date().getDate()
    let month = new Date().getMonth() + 1
    let year = new Date().getFullYear()
    
    const months = [31,28,31,30,31,30,31,31,30,31,30,31]

    const vals = this.state.DOB.split('-')
    const yearDOB = vals[0]
    const monthDOB = vals[1]
    const dateDOB = vals[2]

    if(dateDOB > date){
      date = date + months[month - 1];
      month = month - 1;
    }
    if(monthDOB > month){
      month = month + 12;
      year = year - 1;
    }

    const d = date - dateDOB
    const m = month - monthDOB
    const y = year - yearDOB
    console.log('age -> '+y+' years '+m+' months and '+d+' days years old')
    return y
  }
  setUpCaptcha = (Number) =>{
    const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, firebaseAuth);
    recaptchaVerifier.render();
    return signInWithPhoneNumber(firebaseAuth, Number, recaptchaVerifier)
  }
  
  onSubmitNumber = async (e) =>{
    e.preventDefault();
     try{
         const response = await this.setUpCaptcha(this.state.MNumber);
         console.log(response)
         this.setState({
             confirmationResult:response,
             Captcha : true,
         })
     }catch(err){
        if(err.message === 'Firebase: Error (auth/too-many-requests).'){
          alert('Too many requests Please try again later')
        }else{
          alert(err.message)
        }
     }
  }
  OnSubmitNumber1 = async (e) =>{
    e.preventDefault();

    const validation = await this.validateFields();
    if(!this.state.fill1 && !this.state.fill2 && !this.state.fill3 && !this.state.fill4 && !this.state.fill5 && !this.state.fill6 && !this.state.fill7 && !this.state.fill9 && !this.state.fill10 && !validation){

      const y = this.HandleAge()
      if(y >= 18){

        const Aadhaars = [];
        const querySnapshot = await getDocs(collection(firestore, "AadhaarNo"));
        querySnapshot.forEach((doc) => {
              Aadhaars.push(doc.data().UserAadhaarNo);
            });
          let flag = 0;
            for (let index = 0; index < Aadhaars.length; index++) {
              if(Aadhaars[index]=== this.state.AadhaarNo){
                flag = 1;
              }
            }
            if(flag===1){
              console.log('Aadhaar Present')

              const docRef = await getDoc(doc(firestore, "AadhaarNo", this.state.AadhaarNo));
              const UNumber = docRef.data().UserNumber;
              const UDOB = docRef.data().UserDOB;
              const UName = docRef.data().UserName;

              if(UDOB === this.state.DOB){
                if(UNumber === this.state.MNumber){
                  if(UName === this.state.Name){
                    const Users = [];
                      const querySnapshot = await getDocs(collection(firestore, "Users"));
            
                      querySnapshot.forEach((doc) => {
                        Users.push(doc.data().UserNumber);
                      });
                      let flag = 0;
                        for (let index = 0; index < Users.length; index++) {
                          if(Users[index]=== this.state.MNumber){
                            flag = 1;
                          }
                        }
                        if(flag===1){
                          console.log('User Present please Login')
                          alert('User Present please Login')
                        }else{
                          console.log('User not Present please Register')
                          this.onSubmitNumber(e)
                        }
                  }else{
                    alert("User's Name does not match the Database")
                  }
                }else{
                  alert("User's Mobile Number does not match the Database")
                }
              }else{
                alert("User's Date of Birth does not match the Database")
              }
            }else{
              alert('Aadhaar Invalid - Does not match the database')
            }
      }else{
        alert('You are under the age limit')
      }
    }
        
  }

  handleOTP = async (e) =>{
    e.preventDefault();
    const validationOTP = await this.validateOTP();
    if(!this.state.fill8 && !this.state.fill11 && !validationOTP){
      try{
        const result = await this.state.confirmationResult.confirm(this.state.otp);
        console.log(result.user.phoneNumber)
        await setDoc(doc(firestore, "Users", result.user.phoneNumber), {
          UID : result.user.uid,
          UserName : this.state.Name,
          UserNumber : this.state.MNumber,
          Password : this.state.password,
          Vote : 'False',
        });
        this.props.navigate('/FaceRegister')
      }catch(err){
        if(err.message === 'Firebase: Error (auth/invalid-verification-code).'){
          alert('Invalid OTP')
        }else{
          alert(err.message)
        }
      }
    }
  }
    
  handleNumberValue=(e)=>{
    if((e.key !== "" && e.key >= '0' && e.key <='9') || e.key === "Backspace" || e.key === "Delete" || e.key ==='+'){
      return true
    }else{
      return e.preventDefault()
    }
  }

  validateFields = () => {
    let error = false;
    if(this.state.Name==='' ){
      error = true;
      this.setState({
        fill1:true
      })
    }
    else{
      this.setState({
        fill1:false
      })
    }
    if(this.state.MNumber===''){
      error = true;
      this.setState({
        fill2:true
      })
    }
    else{
      this.setState({
        fill2:false
      })
    }
    if(this.state.MNumber.length < 13){
      error = true;
      this.setState({
        fill9:true
      })
    }
    else{
      this.setState({
        fill9:false
      })
    }
    if(this.state.AadhaarNo===''){
      error = true;
      this.setState({
        fill3:true
      })
    }
    else{
      this.setState({
        fill3:false
      })
    }
    if(this.state.AadhaarNo.length < 12){
      error = true;
      this.setState({
        fill10:true
      })
    }
    else{
      this.setState({
        fill10:false
      })
    }
    if(this.state.DOB===''){
      error = true;
      this.setState({
        fill4:true
      })
    }
    else{
      this.setState({
        fill4:false
      })
    }
    if(this.state.password===''){
      error = true;
      this.setState({
        fill5:true
      })
    }
    else{
      this.setState({
        fill5:false
      })
    }
    if(this.state.CPassword===''){
      error = true;
      this.setState({
        fill6:true
      })
    }
    else{
      this.setState({
        fill6:false
      })
    }
    if(this.state.CPassword !== this.state.password){
      error = true;
      this.setState({
        fill7:true
      })
    }
    else{
      this.setState({
        fill7:false
      })
    }
    return error
  }


  validateOTP = () => {
    let errorOTP = false;
    if(this.state.otp===''){
      errorOTP = true;
      this.setState({
        fill8:true
      })
    }
    else{
      this.setState({
        fill8:false
      })
    }
    if(this.state.otp.length < 6){
      errorOTP = true;
      this.setState({
        fill11:true
      })
    }
    else{
      this.setState({
        fill11:false
      })
    }
    return errorOTP
  }
  render() {
    const {fill1,fill2,fill3,fill4,fill5,fill6,fill7,fill8,fill9,fill10,fill11} = this.state
    return (
      <div className='RS1'>
        <div className='RS1-1'>
          <form>
            {this.state.Captcha ? <ul className='OTPDiv'>
              <h1>REGISTRATION</h1>
              <li className='OTPli'>
                <div>
                  <input type='tel' value={this.state.otp} placeholder='OTP' maxLength={6} onKeyDown={(e)=>this.handleNumberValue(e)} onChange={(e)=>{this.setState({otp: e.target.value})}}></input>
                  {fill8?<span className='Warnings'>Please fill data</span>:""}
                  {fill11?<span className='Warnings'>Please enter a valid OTP</span>:""}
                </div>
              </li>
              <li><button onClick={(e)=> this.handleOTP(e)}>REGISTER</button></li>
            </ul>
            :<ul>
              <h1>REGISTRATION</h1>
              <li>
                <div>
                  <input type='text' placeholder='Name' onChange={(e)=>{this.setState({Name: e.target.value})}}></input>
                  {fill1?<span className='Warnings'>Please fill data</span>:""}
                </div>
              </li>             
              <li>
                <div>
                  <input type='tel' placeholder='Number (Enter +91 before your number)' maxLength={13} onKeyDown={(e)=>this.handleNumberValue(e)} onChange={(e)=>{this.setState({MNumber: e.target.value})}}></input>
                  {fill2?<span className='Warnings'>Please fill data</span>:""}
                  {fill9?<span className='Warnings'>Please enter a valid number</span>:""}
                </div>
              </li>
              <li>
                <div>
                  <input type='tel' placeholder='Aadhaar Number' onChange={(e)=>{this.setState({AadhaarNo: e.target.value})}}></input>
                  {fill3?<span className='Warnings'>Please fill data</span>:""}
                  {fill10?<span className='Warnings'>Please enter a valid Aadhaar number</span>:""}
                </div>
              </li>
              <li>
                <div>
                  <input type='date' onChange={(e)=>{this.setState({DOB: e.target.value})}}></input>
                  {fill4?<span className='Warnings'>Please fill data</span>:""}
                </div>
              </li>
              <li>
                <div>
                  <input type='password' placeholder='Password' onChange={(e)=>{this.setState({password: e.target.value})}}></input>
                  {fill5?<span className='Warnings'>Please fill data</span>:""}
                </div>
              </li>
              <li>
                <div>
                  <input type='password' placeholder='Confirm Password' onChange={(e)=>{this.setState({CPassword: e.target.value})}}></input>
                  {fill6?<span className='Warnings'>Please fill data</span>:""}
                  {fill7?<span className='Warnings'>Password does not match</span>:""}
                </div>
              </li>
              <div className='Captcha' id='recaptcha-container'></div>
              <li><button onClick={(e)=> this.OnSubmitNumber1(e)}>SEND OTP</button></li>
            </ul>}
            {this.state.Captcha ? <></> : <span>Already have an account? <Link to='/Login'>Login here!</Link></span>}
          </form>
        </div>
      </div>
    )
  }
}
export function RegisterH (props){
  const navigate = useNavigate()
  return(<Register navigate={navigate}/>)
}